import React, { useState } from "react";
import style from "./HeaderBody.module.css";
import HeaderIcon from "./HeaderIcon/HeaderIcon";
import SearchBar from "./SearchBar/SearchBar";
import { Grid } from "@material-ui/core";
import { useMediaQuery } from "@material-ui/core";
import CarouselModel from "./CarouselModel/CarouselModel";

const HeaderBody = () => {
  const [handleOpen, setHandleOpen] = useState({ open: false });
  const handleClick = (e) => {
    e.preventDefault();
    setHandleOpen({ open: true });
  };
  const matches = useMediaQuery("(max-width:600px)");

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      justify="space-between"
      className={style.headerBody}
    >
      <Grid item xs={12} md={5}>
        <SearchBar handleClick={handleClick} />
      </Grid>
      <Grid item xs={12} md={6}>
        <HeaderIcon />
      </Grid>

      <Grid item lg={12}>
        <CarouselModel
          isMobile={matches}
          handleOpen={handleOpen}
          setHandleOpen={setHandleOpen}
        />
      </Grid>
    </Grid>
  );
};

export default HeaderBody;
